import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const paymentTokenData = z.object({
  h: z.number(),
  a: z.number(),
  g: z.string(),
  id: z.string(),
  l: z.string(),
});

export class PaymentTokenData extends createZodDto(paymentTokenData) {}

export const paymentTokenDto = z.object({
  ...paymentTokenData.shape,
  iat: z.number(),
  exp: z.number(),
});

export class PaymentTokenDto extends createZodDto(paymentTokenDto) {}
